export default function AnimatedBackground() {
  // Common style for all blobs to keep the JSX clean
  const blobBaseStyle = {
    position: "absolute",
    filter: "blur(60px)",
    mixBlendMode: "screen", // Helps colors blend naturally
    zIndex: 0,
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        zIndex: 0,
        overflow: "hidden",
        background:
          "radial-gradient(circle at center, #1a1a3e 0%, #0a0e27 100%)",
      }}
    >
      {/* --- ORGANIC SHAPES (BLOBS) --- */}

      {/* Blob 1 - Pink */}
      <div
        style={{
          ...blobBaseStyle,
          width: "500px",
          height: "500px",
          background: "#FF006E",
          top: "-15%",
          left: "15%",
          animation:
            "morph 15s ease-in-out infinite, float1 20s infinite alternate",
        }}
      />

      {/* Blob 2 - Cyan */}
      <div
        style={{
          ...blobBaseStyle,
          width: "600px",
          height: "600px",
          background: "#00D4FF",
          bottom: "20%",
          right: "5%",
          animation:
            "morph 18s ease-in-out infinite reverse, float2 25s infinite alternate",
        }}
      />

      {/* Blob 3 - Purple */}
      <div
        style={{
          ...blobBaseStyle,
          width: "1000px",
          height: "500px",
          background: "#8338EC",
          top: "45%",
          left: "0%",
          animation:
            "morph 12s ease-in-out infinite, float3 22s infinite alternate",
        }}
      />

      {/* Blob 4 - Yellow */}

      <div
        style={{
          position: "absolute",

          width: "350px",

          height: "350px",

          background: "#FFBE0B",

          borderRadius: "68% 32% 42% 58% / 52% 48% 52% 48%",

          filter: "blur(80px)",

          animation: "float4 17s ease-in-out infinite",

          bottom: "15%",

          right: "12%",

          opacity: 0.6,
        }}
      />

      {/* Blob 5 - Lime */}

      <div
        style={{
          position: "absolute",

          width: "380px",

          height: "380px",

          background: "#06D6A0",

          borderRadius: "35% 65% 53% 47% / 62% 38% 62% 38%",

          filter: "blur(80px)",

          animation: "float5 19s ease-in-out infinite",

          top: "50%",

          left: "20%",

          opacity: 0.5,
        }}
      />

      {/* --- THE GLASS OVERLAY --- */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // Glass effect: faint white tint + heavy blur
          background: "rgba(255, 255, 255, 0.02)",
          backdropFilter: "blur(100px) saturate(160%)",
          WebkitBackdropFilter: "blur(100px) saturate(160%)",
          zIndex: 1,
        }}
      />

      <style>{`
        /* The "Organic" Morphing Effect */
        @keyframes morph {
          0%, 100% { border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%; }
          33% { border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%; }
          66% { border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%; }
        }

        /* Movement Animations */
                @keyframes float1 {

          0% {

            transform: translate(0, 0) rotate(0deg);

          }

          25% {

            transform: translate(80px, -120px) rotate(90deg);

          }

          50% {

            transform: translate(40px, 100px) rotate(180deg);

          }

          75% {

            transform: translate(-100px, 60px) rotate(270deg);

          }

          100% {

            transform: translate(0, 0) rotate(360deg);

          }

        }



        @keyframes float2 {

          0% {

            transform: translate(0, 0) rotate(0deg);

          }

          25% {

            transform: translate(-100px, 80px) rotate(90deg);

          }

          50% {

            transform: translate(-60px, -100px) rotate(180deg);

          }

          75% {

            transform: translate(120px, -40px) rotate(270deg);

          }

          100% {

            transform: translate(0, 0) rotate(360deg);

          }

        }



        @keyframes float3 {

          0% {

            transform: translate(0, 0) rotate(0deg);

          }

          25% {

            transform: translate(90px, 100px) rotate(90deg);

          }

          50% {

            transform: translate(-80px, 60px) rotate(180deg);

          }

          75% {

            transform: translate(40px, -120px) rotate(270deg);

          }

          100% {

            transform: translate(0, 0) rotate(360deg);

          }

        }



        @keyframes float4 {

          0% {

            transform: translate(0, 0) rotate(0deg);

          }

          25% {

            transform: translate(-120px, -60px) rotate(90deg);

          }

          50% {

            transform: translate(100px, -80px) rotate(180deg);

          }

          75% {

            transform: translate(-40px, 120px) rotate(270deg);

          }

          100% {

            transform: translate(0, 0) rotate(360deg);

          }

        }



        @keyframes float5 {

          0% {

            transform: translate(0, 0) rotate(0deg);

          }

          25% {

            transform: translate(70px, 110px) rotate(90deg);

          }

          50% {

            transform: translate(-110px, -70px) rotate(180deg);

          }

          75% {

            transform: translate(60px, 80px) rotate(270deg);

          }

          100% {

            transform: translate(0, 0) rotate(360deg);

          }

        }

      `}</style>
    </div>
  );
}
